import { render, staticRenderFns } from "./comp_ProductCard-Actions.vue?vue&type=template&id=b0974aae&scoped=true"
import script from "./comp_ProductCard-Actions.vue?vue&type=script&lang=js"
export * from "./comp_ProductCard-Actions.vue?vue&type=script&lang=js"
import style0 from "./comp_ProductCard-Actions.vue?vue&type=style&index=0&id=b0974aae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0974aae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VFadeTransition})
